import { getReadingViewType } from "./setReadingViewType";
// TODO: this function seems unecessary
export function getTemplateData(plan) {
    const type = getReadingViewType();
    return Object.assign(Object.assign({}, plan), { monthLayout: type === "month", weekLayout: type === "week" });
}
